/**
 * Оборачивает все таблицы внутри .content-section в div.table-wrapper
 */
$(document).ready(function () {
    $('.content-section table').each(function () {
        if (!$(this).parent().hasClass('table-wrapper')) {
            $(this).wrap('<div class="table-wrapper"></div>');
        }

        console.log('wrap');
    });

    console.log('wrap init');
});
